import React from 'react';
import { withTranslation } from "react-i18next";
import "./TerminalReport.scss";
import { WebCache } from '../../services/WebCache';
import i18next from "i18next";
import { Option } from '../../models/Option';
import TaxDocumentationTemplate from "./FiscalDocumentInvoicesTemplate";
interface IProps {
}

interface IState {
}
class TaxDocumentation extends React.Component<IProps, IState> {

    getPrefix = () => {
        return WebCache.isUserUYU()?'pages.fiscalDocumentInvoices.':'pages.posnetPlatformInvoices.';
    }

    getAllDocumentTypes = () => {
        return i18next.t<Array<Option>>(`${this.getPrefix()}documentTypes`, { returnObjects: true }).map((documentType, documentTypeIndex) => {
            return { key: String(documentTypeIndex), ...documentType, disabled: false };
        })
    }

    render() {
        return (
            <TaxDocumentationTemplate maxDayRange={30} invoiceOrigin={1} documentTypeOptions={WebCache.isUserARG()?this.getAllDocumentTypes():this.getAllDocumentTypes().filter(row=>row.value !="8")} showDocumentTypes={WebCache.isUserUYU()}  prefix={this.getPrefix()}></TaxDocumentationTemplate>
        )
    };
}

export default withTranslation()(TaxDocumentation);
